// AppError -- thrown by app code to control which recovery actions the error
// screen offers. The action list drives which recovery buttons render.
export type ErrorAction = 'retry' | 'reload' | 'signout' | 'clearcache'

export class AppError extends Error {
  readonly actions: ReadonlyArray<ErrorAction>

  constructor(message: string, actions: ErrorAction[]) {
    super(message)
    this.name = 'AppError'
    this.actions = actions
  }
}
